/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeAUpRightIcon24Solid = forwardRef('ArrowShapeAUpRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M18.124 3.249a2.625 2.625 0 0 1 2.625 2.625v12.814c0 1.336-1.615 2.006-2.56 1.06l-2.97-2.97-4.253 4.254a2.25 2.25 0 0 1-3.182 0l-4.816-4.817a2.25 2.25 0 0 1 0-3.181L7.221 8.78 4.25 5.811c-.945-.946-.276-2.561 1.06-2.561l12.814-.001Z" })));
});
